// Playwright Regression — action types + creators
// Kicks off the playwright-regression-agent Fargate pipeline (loads the
// deployed x20-creative.com end-to-end, captures PNG snapshots, uploads
// outline.json, signals completion via SNS — which downstream renders a
// regression-snapshots deck.pptx through agent-x20-research-deck).
//
// Uses the same AppSync triggerAdAgencyJob mutation as research-deck and
// reporter-agent, with jobType "TRIGGER_PLAYWRIGHT_REGRESSION_JOB".
//
// State surface kept narrow: one submit action (the page only has a single
// "Run Regression" CTA) plus a reset for navigating away.

export const TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST =
  "TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST";
export const TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS =
  "TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS";
export const TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE =
  "TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE";

export const RESET_PLAYWRIGHT_REGRESSION_STATE =
  "RESET_PLAYWRIGHT_REGRESSION_STATE";

export const triggerPlaywrightRegressionRequest = (payload) => ({
  type: TRIGGER_PLAYWRIGHT_REGRESSION_REQUEST,
  payload,
});
export const triggerPlaywrightRegressionSuccess = (result) => ({
  type: TRIGGER_PLAYWRIGHT_REGRESSION_SUCCESS,
  payload: result,
});
export const triggerPlaywrightRegressionFailure = (error) => ({
  type: TRIGGER_PLAYWRIGHT_REGRESSION_FAILURE,
  error,
});

export const resetPlaywrightRegressionState = () => ({
  type: RESET_PLAYWRIGHT_REGRESSION_STATE,
});
